export type Direction = 'left' | 'right' | 'up' | 'down';

export const getNextFocusedButtonGridIndex = (
  direction: Direction,
  index: number | null,
  buttonRefArrayLength: number,
): number => {
  if (index === null) return 0;

  if (direction === 'up') {
    return index - 2 < 0 ? index : index - 2;
  }

  if (direction === 'down') {
    return index + 2 > buttonRefArrayLength - 1 ? index : index + 2;
  }

  if (direction === 'left') {
    return index - 1 < 0 ? buttonRefArrayLength - 1 : index - 1;
  }

  // when direction is right
  return index + 1 >= buttonRefArrayLength ? 0 : index + 1;
};

export const getNextFocusedButtonColumnIndex = (
  direction: Direction,
  index: number | null,
  buttonRefArrayLength: number,
): number => {
  if (index === null) return 0;

  if (direction === 'up') return index - 1 < 0 ? index : index - 1;
  if (direction === 'down') return index + 1 >= buttonRefArrayLength ? index : index + 1;

  // when direction is left and right, do nothing
  return index;
};
